import axios from "axios";
import Login from "./pages/Authentication/Login";

// Créez une instance Axios avec des configurations par défaut
const axiosInstance = axios.create( {
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    // 'Content-Type': 'application/json'
  },
} );

// Ajouter un intercepteur pour les requêtes
axiosInstance.interceptors.request.use(
  ( config ) =>
  {
    // Récupérer le token de localStorage ou localStorage
    const sessionAuth = JSON.parse( localStorage.getItem( "authUser" ) );
    const localAuth = JSON.parse( localStorage.getItem( "authUser" ) );
    const token = sessionAuth?.accessToken || localAuth?.accessToken || null;
    // console.log("Token AxiosInstance: ", token);
    // console.log( "localAuth?.accessToken: ", localAuth?.accessToken )

    // Si le token existe, l'ajouter aux en-têtes de la requête
    if ( token )
    {
      config.headers.Authorization = `Bearer ${ token }`;
    } else
    {
      // Redirection manuelle sans `useHistory`
      window.location.href = "/login";
    }

    return config;
  },
  ( error ) =>
  {
    // Gérer les erreurs de requête
    return Promise.reject( error );
  }
);

export default axiosInstance;
